export default "__VITE_ASSET__c4d1e7e4__"